import React from 'react'
import ExperienceBox from '../components/experience-box'
import CTA from '../components/cta'

const WorkPage = ({ data }) => (
  <section>
    <h3>Work</h3>
    <section id='work' className='container'>
      {data.allExperienceYaml.edges.map(({ node }, index) =>
        <ExperienceBox
          key={index}
          name={node.name}
          role={node.role}
          logo={node.logo}
          tags={node.tags}
          color={node.color}
          shortDescription={node.shortDescription}
        />
      )}
    </section>

    <CTA primary={{to: '/thoughts', text: 'Read Thoughts'}} scrollToTop={true} />
  </section>
)

export default WorkPage

export const query = graphql`
query WorkQuery {
  allExperienceYaml {
    edges {
      node {
        name
        role
        shortDescription
        logo
        color
        tags
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/pages/work.js